import React from 'react';
import {SnackBarProvider} from './SnackBarProviders';
import {AuthProvider} from './AuthProvider';
import {CategoryProvider} from "./CategoryProvider";


export const ContextProviders = ({children}: any) => {
    return (
        <AuthProvider>
            <SnackBarProvider>
                <CategoryProvider>
                    {children}
                </CategoryProvider>
            </SnackBarProvider>
        </AuthProvider>
    );
};
